import { render, staticRenderFns } from "./ChangePassTemp.vue?vue&type=template&id=3a5a1b8a&"
import script from "./ChangePassTemp.vue?vue&type=script&lang=js&"
export * from "./ChangePassTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports